const comment = {
  title: "Comments",
  commentPlaceholder: "Sample Text",
  tableTitle: "Comment History",
  tableDescription:
    "Use the comments section to note interactions with the creditor that do not require the upload of a document.",
  deleteMessage: "Are you sure you want to delete this comment",
  commentEdit: {
    title: "Edit Comment",
    requiredMessage: "Comment is required",
    label: "Comment",
  },
  tableCoumnsDetails: {
    comment: "Comment",

    postedOn: "Posted On",

    postedBy: "Posted By",
  },
};

export default comment;
